import isEmpty from 'lodash/isEmpty';
import { isTimeEnded, convertDateTimeToETTimezone } from 'core/utils/helpers/date';
import { convertDollarAmountToNumber } from 'core/utils/helpers/numbers';

export const parseBonusButton = (bonusButton) => {
  if (isEmpty(bonusButton)) return {};

  const { startDate, endDate, offers } = bonusButton;
  const offer = offers[0] || {};
  const {
    maxRewardAvailable, minSpendToQualify, qualifyingActions = [], totalAmountSpent = '$0', qualifyingSpendTiers, terms,
  } = offer;

  const { displaySettings, isQualified } = qualifyingActions[0] || {};
  const { contentTemplate } = displaySettings;
  const tier = qualifyingSpendTiers[0];
  const { brandCurrency } = tier;

  const totalAmountSpentNumber = convertDollarAmountToNumber(totalAmountSpent);
  const minSpendToQualifyNumber = convertDollarAmountToNumber(minSpendToQualify);
  const isEnded = isTimeEnded(endDate);

  const getLeftAmount = () => {
    const amount = minSpendToQualifyNumber - totalAmountSpentNumber;
    return amount > 0 ? amount : 0;
  };

  return {
    startDate: convertDateTimeToETTimezone(startDate), // Bonus start date
    endDate: convertDateTimeToETTimezone(endDate), // Bonus end date
    isEnded, // is Bonus ended
    maxRewardAvailable, // the maximum reward available for the user
    minSpendToQualify, // the overall amount of $$$ needed to be earned to reach the threshold
    leftAmount: getLeftAmount(), // How much more $$$ the user needs to spend to reach the threshold
    isQualified, // whether the user is qualified (without taking into account if they have reached the threshold)
    totalAmountSpentNumber, // the total amount of $$$ spent by the user so far
    contentTemplate, // 'pop-up' or 'lightbox' identificator
    brandCurrency, // currency (e.g., miles, points)
    terms, // Bonus terms
  };
};
